export default function ThreeHorizonsCalculator() {
  return <div>ThreeHorizonsCalculator</div>;
}
